
export const VERSION = '5.4.21'; // Update this manually on each release

